module.exports = __webpack_public_path__ + "static/media/formes-preview.bf7cfc75.svg";